import { combineReducers } from 'redux';
import ACTIONS from './actions';

const userTree = (state = {}, action) => {
    switch (action.type) {
        case ACTIONS.LOGGED_USER:
            return {
                ...state,
                loggedInUser: action.loggedInUser
            };
        case ACTIONS.LOAD_USER_PREFS:
            return {
                ...state,
                userPrefs: action.userPrefs
            };
        default:
            return state;
    }
};

export default combineReducers({
    userTree
});
